/**
 *
 * @returns Configuração do whitelabel a partir do arquivo JSON hospedado na raiz do domínio
 *
 * Componente para conexão com APIs utilizando a configuração do whitelabel.
 * Busca o arquivo config-whitelabel.json na raiz do domínio.
 * Retorna os dados de configuração do whitelabel.
 *
 */

//whitelabel
export const getConfigWhitelabel = async () => {
  try {
    let hostname =
      window.location.protocol +
      "//" +
      window.location.hostname.replace(/(\/+|\/*\#.*)$/, "");
    if (
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1"
    ) {
      hostname = window.location.href;
    }
    const response = await fetch(`${hostname}/config-whitelabel.json`);
    const data = await response.json();
    return data;
  } catch (err) {
    console.log("getConfigWhitelabel: ", err);
  }
};

//ws dos correios para busca de CEP
export const getAddressByCEP = async (cep: any) => {
  try {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    const data = await response.json();
    return data;
  } catch (err) {
    console.log("getAddressByCEP: ", err);
  }
};

// Função auxiliar para GET com fetch
const fetchGet = async (url: string, options: any = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  const params = options.params
    ? "?" +
      Object.entries(options.params)
        .map(
          ([key, val]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(String(val))}`,
        )
        .join("&")
    : "";
  try {
    //console.log("fetchGet url", `${url}${params}`);
    const response = await fetch(`${url}${params}`, { headers });
    const data = await response.json();
    return { data };
  } catch (error: any) {
    //console.log("fetchGet error", error);
    return { data: error?.response?.data };
  }
};

// Função auxiliar para POST com fetch
const fetchPost = async (url: string, body: any, options: any = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  try {
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });
    const data = await response.json();
    return { data };
  } catch (error: any) {
    return { data: error?.response?.data };
  }
};

// Função auxiliar para PUT com fetch
const fetchPut = async (url: string, body: any, options: any = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers,
      body: JSON.stringify(body),
    });

    const data = await response.json();
    return { data };
  } catch (error: any) {
    return { data: error?.response?.data };
  }
};

// Função auxiliar para PATCH com fetch
const fetchPatch = async (url: string, body: any, options: any = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  try {
    const response = await fetch(url, {
      method: "PATCH",
      headers,
      body: JSON.stringify(body),
    });

    const data = await response.json();
    return { data };
  } catch (error: any) {
    return { data: error?.response?.data };
  }
};

//APIs
//create session
export const postSession = async (url: any, clapi_vcds_code: any) => {
  try {
    const response = await fetchPost(`${url}ws_loginaplicacao/`, {
      clapi_vcds_code,
    });
    return response?.data;
  } catch (err) {
    console.log("postSession", err);
  }
};

//getVisualIdentity
export const getVisualIdentity = async (url: any, clapi_vcds_code: any) => {
  try {
    const response = await fetchGet(`${url}ws_loginaplicacao/`, {
      params: { clapi_vcds_code: clapi_vcds_code },
    });
    return response?.data;
  } catch (err) {
    console.log("getVisualIdentity", err);
  }
};

//search federative unit
export const getFederativeUnit = async (
  url: any,
  accessToken: any,
  uf: any,
) => {
  try {
    const response = await fetchGet(`${url}ws_certificadodigital/`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: {
        servico: "listarCidadesPorUF",
        ambiente: "H",
        uf: uf,
      },
    });
    return response?.data;
  } catch (err) {
    console.log("getFederativeUnit: ", err);
  }
};

//get client
export const getClient = async (url: any, accessToken: any, cliente: any) => {
  try {
    const response = await fetchGet(`${url}ws_cliente/`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: cliente,
    });
    return response?.data;
  } catch (err) {
    console.log("getClient", err);
  }
};

//others APIs
//get holidays in Brazil
export const getHolidays = async (year: any) => {
  try {
    const response = await fetch(
      `https://brasilapi.com.br/api/feriados/v1/${year}`,
    );
    const data = await response.json();
    const holidayDates = data.map((holiday: any) => {
      const [month, day] = holiday.date.split("-");
      return `${parseInt(month)}/${parseInt(day)}`; // Formato "Mês/Dia"
    });
    return holidayDates;
  } catch (error) {
    console.error("Erro ao buscar feriados:", error);
  }
};

// get Vouchers
export const getVouchers = async (
  url: string,
  accessToken: string,
  vouch_vcnu_voucher: string,
  vouch_dmtp_documento: string,
  vouch_dmnu_documento: string,
) => {
  try {
    const response = await fetchGet(`${url}ws_voucher/`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: {
        vouch_vcnu_voucher,
        vouch_dmtp_documento,
        vouch_dmnu_documento,
      },
    });
    return response?.data;
  } catch (err) {
    console.log("getVouchers", err);
  }
};

export const patchClient = async (
  url: string,
  accessToken: string,
  data: any,
) => {
  try {
    //     fetch(`${url}ws_voucher/`, {
    //   method: 'POST', // POST simples evita o preflight OPTIONS em vários cenários
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded',
    //   },
    //   body: new URLSearchParams({
    //     '_method': 'PATCH', // Avisa o PHP que a intenção é um PATCH
    //     'nome': 'Novo Nome'
    //   })
    // });

    // axios({
    //   method: "patch",
    //   url: `${url}ws_voucher/`,
    //   headers: {
    //     // "Content-Type": "application/json",
    //     Authorization: `Bearer ${accessToken}`,
    //     // "Access-Control-Allow-Origin": "*",
    //     // "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    //     // "Access-Control-Allow-Headers": "Content-Type, Authorization",
    //     // Não adicione cabeçalhos customizados pesados se o backend não permitir
    //   },
    //   data: JSON.stringify(data),
    // })
    //   .then((res) => res.data)
    //   .then((data) => console.log("patchClient response", data))
    //   .catch((err) => console.error("patchClient error", err));

    // fetch(`${url}ws_voucher/`, {
    //   method: 'PATCH',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Authorization: `Bearer ${accessToken}`,
    //     "Request-Method": "Patch", // Adicione este cabeçalho para indicar o método PATCH
    //     "Access-Control-Allow-Origin": "*",
    //     "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    //     "Access-Control-Allow-Headers": "Content-Type, Authorization",
    //     // Não adicione cabeçalhos customizados pesados se o backend não permitir
    //   },
    //   body: JSON.stringify({ data }),
    // })
    // .then(res => res.json())
    // .then(data => console.log(data))
    // .catch(err => console.error(err));

    // const response = await fetch(`${url}ws_voucher/`, {
    //   method: "PATCH",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${accessToken}`,
    //   },
    //   body: data,//JSON.stringify(data),
    // });
    // console.log("patchClient response", response);
    // const responseData = await response.json();
    // return responseData;

    //       const body = JSON.stringify(data);
    //       const config: AxiosRequestConfig = {
    //     method: "GET",
    //     url: `http://172.16.1.22/ws_voucher/`, //${url}
    //     // data: body,
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${accessToken}`,
    //     },
    //   };
    //   const client = axios.create({
    //   baseURL: config?.url,
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // });
    // await client(config)
    // return callJupiterAPI("ws_contratocliente/", "patch", body).catch(
    //   (error: any) => {
    //     console.log("Error in userEnableModule:", error?.response?.data);
    //     return { data: error?.response?.data };
    //   },
    // );
    // }
    // const response = await fetchGet(`http://172.16.1.22/jupiter/ws_voucher/`, {
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${accessToken}`
    //   },
    //   params: {
    //     vouch_vcnu_voucher: data?.vouch_vcnu_voucher,
    //     vouch_dmtp_documento: data?.vouch_dmtp_documento,
    //     vouch_dmnu_documento: data?.vouch_dmnu_documento,
    //   },
    // });
    // return response?.data;

    const response = await fetch(`${url}ws_voucher/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    });
    const responseData = await response.json();
    return responseData;
  } catch (err) {
    console.log("patchClient", err);
  }
};

export const patchClientVoucher = async (
  url: string,
  accessToken: string,
  data: any,
) => {
  try {
    const response = await fetchPatch(`${url}ws_voucher/`, data, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response?.data;
  } catch (err) {
    console.log("patchClientVoucher", err);
  }
};
